import { memo } from 'react'

import ThemeProvider from './ThemeProvider'

/**
 * HOC that wraps component in a ThemeProvider. Helps when a component needs a
 * different variant of the theme but also has its own styles.
 * @type {(mode: import('./ThemeProvider').ThemeProviderProps['mode']) => <P>(Component: React.ComponentType<P>) => React.ComponentType<P>}
 */
function withThemeProvider(mode) {
  return (Component) => {
    return memo((props) => {
      return (
        <ThemeProvider mode={mode}>
          <Component {...props} />
        </ThemeProvider>
      )
    })
  }
}

export default withThemeProvider
